module.exports = __webpack_public_path__ + "img/业务介绍物业1.5debf076.jpg";